import React, { useState } from "react";
import { SketchPicker } from "react-color";

const CustomColorPicker = ({ color, onChange }) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      {/* Swatch like native input */}
      <div
        onClick={() => setShowPicker(!showPicker)}
        className="color-box"
        style={{
          background: color,
        }}
      />

      {/* Popover */}
      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 2,
            top: "45px",
          }}
        >
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            onClick={() => setShowPicker(false)}
          />
          <SketchPicker color={color} onChange={(c) => onChange(c.hex)} />
        </div>
      )}
    </div>
  );
};

export default CustomColorPicker;
